import { render, staticRenderFns } from "./ApprovePositionDescriptionDialog.vue?vue&type=template&id=18ae68dc&scoped=true&"
import script from "./ApprovePositionDescriptionDialog.vue?vue&type=script&lang=js&"
export * from "./ApprovePositionDescriptionDialog.vue?vue&type=script&lang=js&"
import style0 from "./ApprovePositionDescriptionDialog.vue?vue&type=style&index=0&id=18ae68dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae68dc",
  null
  
)

export default component.exports